<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item>
            <a-input style="width:160px" class="search-input" placeholder="请输入实践活动名称" v-model="form.name"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-select placeholder="请选择活动状态" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.status">
              <a-select-option v-for="(item, index) in statusArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select placeholder="请选择实践学期" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.term">
              <a-select-option v-for="(item, index) in activityTerm" :key="index" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-select placeholder="请选择实践课程" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.course">
              <a-select-option v-for="(item, index) in trainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select show-search notFoundContent="暂无匹配班级" option-filter-prop="children"  placeholder="请选择实践班级" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.class_id">
              <a-select-option v-for="(item, index) in activityClass" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-input style="width:160px" class="search-input" placeholder="请输入负责教师" v-model="form.teacher"></a-input>
          </a-form-model-item>

          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSubmit">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>

        </a-form-model>
          <div class="right-option-box">
            <a-button class="option-btn" type="primary" @click="createTeach()">创建实践教学活动</a-button>
          </div>
      </div>
      <template>
        <div class="event-list" v-if="eventData&&eventData.length>0">
          <div class="event-item" v-for="item,index in eventData" :key="index">
            <div class="event-status" :class="[item.status == 2 ?'event-close':'']"></div>
            <div class="event-cover">
              <div class="cover-img" :style="`background:url(${item.cover})no-repeat center/cover`"></div>
            </div>
            <div class="event-text">
              <a-popover class="a-popover" v-if="item.name && item.name.length > 20" placement="bottom">
                <template slot="content">
                  {{ item.name }}
                </template>
                <div class="event-name">{{ item.name }}</div>
              </a-popover>
              <div v-else class="event-name">{{ item.name }}</div>
              
              <div class="event-semester"><span>实践学期：</span>{{ item.term_name }}</div>
              <div class="event-teacher">
                <a-popover v-if="item.teacher_names && item.teacher_names.length > 22" placement="bottom">
                  <template slot="content">
                    <div>{{ item.teacher_names }}</div>
                  </template>
                  <span>负责教师：</span>{{ item.teacher_names }}
                </a-popover>
                <template v-else><span>负责教师：</span>{{ item.teacher_names }}</template>
              </div>
              <div class="event-class">
                <a-popover v-if="item.class_names && item.class_names.length > 22" placement="bottom">
                  <template slot="content">
                    <div>{{ item.class_names }}</div>
                  </template>
                  <span>实践班级：</span>{{ item.class_names }}
                </a-popover>
                <template v-else> <span>实践班级：</span>{{ item.class_names }}</template>
              </div>
              <div class="event-button">
                <div class="button-item" @click="handleClick(item)">管理活动</div>
                <div class="button-item" @click="handleDelete(item)">删&nbsp;&nbsp;除</div>
              </div>
            </div>
          </div>
        </div>
        <template v-else>
          <a-empty />
        </template>

        <!-- show-size-changer @showSizeChange="onShowSizeChange" -->
        <a-pagination v-model="page" :total="total" :pageSize="size" @change="onChange" />
      </template>

    </div>
    <CommonModal v-model="showDeleteModal" title="删除确认" confirmText="确定" @confirm="handleDeleteConfirm" width="450px">
      <div class="delete-modal">
        学生实践数据将同步删除，确定删除活动吗？
      </div>
    </CommonModal>

  </div>
</template>
<script>
import Bread from "../../../components/school/Bread.vue"
import CommonModal from "../../../components/CommonModal.vue"

import services from "../../../assets/js/services";
import { mapState, mapActions } from "vuex";
export default {
  data () {
    return {
      breadConfig: [
        { name: "实践教学活动" },
      ],
      school_code: localStorage.getItem("schoolCode"),
      eventData: [],
      total: 500,
      page: 1,
      size: 10,
      form: {
        name: undefined,
        teacher: undefined,
        course: undefined,
        term: undefined,
        status: undefined,
        class_id: undefined,
      },
      statusArr: [
        { id: 1, name: "开课" },
        { id: 2, name: "结课" },
      ],
      showDeleteModal: false,
      delete_id: "",
    }
  },
  components: {
    Bread,
    CommonModal
  },
  computed: {
    ...mapState({
      activityTerm: state => state.teachEvent.activityTerm,
      trainCourse: state => state.teachEvent.trainCourse,
      activityClass: state => state.teachEvent.activityClass,
    }),
  },
  mounted () {
    this.getActivityClass({
      page: 1, size: 999
    })
    this.getTrainCourse()
    this.getActivityTerm()
    this.getData()
  },
  methods: {
    ...mapActions(["getActivityTerm", "getTrainCourse", "getActivityClass"]),
    handleDelete (item) {
      this.delete_id = item.id
      this.showDeleteModal = true
    },
    async handleDeleteConfirm () {
      let result = await services.updateSchoolActivity({ id: this.delete_id, _method: "delete" })
      if (result.code == "0000") {
        this.$message.success("删除成功!")
        this.page = 1
        this.getData()
      } else {
        this.$message.success(result.message)
      }
      this.showDeleteModal = false
    },
    onShowSizeChange (current, pageSize) {
      this.page = current
      this.size = pageSize
      this.getData()
    },
    async getData () {
      let { name, course, status, term, teacher, class_id } = this.form
      let result = await services.getSchoolActivityData({ page: this.page, size: this.size, active_name: name, status, course_id: course, class_id, teacher_name: teacher, term })
      if (result.code == '0000') {
        this.eventData = result.data.items
        this.total = result.data.total
      }
    },
    onChange () {
      this.getData()
    },
    onSubmit () {
      this.getData()
    },
    resetForm () {
      this.form = {
        name: undefined,
        status: undefined,
        term: undefined,
        course: undefined,
        class: undefined,
        teacher: undefined
      };
      this.page = 1
      this.getData()
    },
    createTeach () {
      this.$router.push(`/${this.school_code}/school/teach/create`)
    },
    handleClick (item) {
      this.$router.push(`/${this.school_code}/school/activity/manage?id=${item.id}`)
    },
  },

}
</script>

<style lang="less" scoped>
.eol-container-box {
    .event-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .event-item {
            display: flex;
            margin-bottom: 32px;
            width: calc(50% - 22px);
            height: 210px;
            background: linear-gradient(
                0deg,
                #ffffff 0%,
                #ffffff 82%,
                #fff1f1 100%
            );
            border-radius: 0 4px 4px 0;
            overflow: hidden;
            position: relative;
            .event-status {
                width: 50px;
                height: 26px;
                background: #3f82f2;
                border-radius: 0px 0px 12px 0px;
                border: 1px solid #ffffff;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                &::before {
                    content: '';
                    width: 27px;
                    height: 12px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url('../../../assets/image/school/teach/course-open.png')
                        no-repeat center/cover;
                }
                &.event-close {
                    background: #7f8892;
                    &::before {
                        background: url('../../../assets/image/school/teach/course-close.png')
                            no-repeat center/cover;
                    }
                }
            }
            &:hover {
                .event-cover {
                    .cover-img {
                        transform: scale(1.1);
                    }
                }
            }
            .event-cover {
                width: 280px;
                height: 100%;
                overflow: hidden;
                .cover-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.3s;
                }
            }
            .event-text {
                flex: 1;
                padding: 20px 24px 24px;
                border: 1px solid #e3ebf3;
                border-left: none;
                border-radius: 0 4px 4px 0;
                overflow: hidden;
                div {
                    font-weight: 400;
                    font-size: 14px;
                    color: #45464b;
                    overflow: hidden;
                    text-wrap: nowrap;
                    text-overflow: ellipsis;
                    margin-bottom: 5px;
                }
                span {
                    color: #45464b;
                }
                .event-name {
                    font-weight: bold;
                    font-size: 16px;
                    color: #333132;
                    height: 40px;
                    line-height: 20px;
                    margin-bottom: 10px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; /* 限制文本为2行 */
                    overflow: hidden;
                    text-wrap: wrap;
                    text-overflow: ellipsis;
                }
                .event-button {
                    margin-top: 14px;
                    display: flex;
                    align-items: center;
                    .button-item {
                        padding: 4.5px 15px;
                        background: #fff3f2;
                        border-radius: 16px;
                        border: 1px solid #cc9d9a;
                        font-size: 14px;
                        color: #a82822;
                        &:not(:last-child) {
                            margin-right: 16px;
                        }
                        cursor: pointer;
                        &:hover {
                            background: #ffe3e1;
                        }
                    }
                }
            }
        }
    }
}

.ant-form-inline .ant-form-item {
    margin-right: 12px;
}
.search-all-box .right-option-box {
    padding-top: 0;
}
@media screen and (max-width: 1280px) {
    .eol-container-box .event-list .event-item {
        width: 100%;
    }
}
@media screen and (max-width: 1800px) {
    .search-all-box .option-btn.ant-btn.ant-btn-primary {
        margin-left: 0;
    }
}
.delete-modal {
    font-weight: bold;
    font-size: 16px;
    color: #373536;
    text-align: center;
}
</style>